import { useEffect, useRef } from "react";
import M from "materialize-css";
import NavbarTabs from "../components/NavbarTabs";
import { useNavigate } from "react-router-dom";
import { useAuth } from "react-oidc-context";

const Navbar = () => {
  const auth = useAuth();
  const navigate = useNavigate();
  const sidenavRef = useRef(null);
  const sidenavInstanceRef = useRef(null);

  const signOutRedirect = () => {
    const clientId = process.env.REACT_APP_CLIENT_ID;
    const logoutUri = `https://${process.env.REACT_APP_DOMAIN_NAME}`;
    const cognitoDomain = `https://${process.env.REACT_APP_COGNITO_DOMAIN}`;
    auth.removeUser();
    window.location.href = `${cognitoDomain}/logout?client_id=${clientId}&logout_uri=${encodeURIComponent(logoutUri)}`;
  };

  useEffect(() => {
    if (sidenavRef.current) {
      sidenavInstanceRef.current = M.Sidenav.init(sidenavRef.current, {edge: "right",});
    }
  }, []);

  const handleClick = (value) => {
    if (sidenavInstanceRef.current) {
      sidenavInstanceRef.current.close();
    }

    if (value === 'login') {
      auth.signinRedirect();
    } else if (value === 'logout') {
      signOutRedirect();
    } else {
      navigate('/' + value);
    }

  };

  return (
    <>
      <div className="navbar-fixed" style={{ marginBottom: '15px'}}>
        <nav>
          <div className="nav-wrapper black" >
            <span className="brand-logo" style={{ paddingLeft: "10px" }}>RILA Rates</span>
            <button className="sidenav-trigger right hide-on-large-only btn-flat white-text" data-target="mobile-menu">
                <i className="material-icons">menu</i>
            </button>

            <ul className="right hide-on-med-and-down" style={{ paddingRight: "10px" }}>
              <NavbarTabs onSelect={handleClick}/>
            </ul>
          </div>
        </nav>
      </div>

      <ul className="sidenav center" id="mobile-menu" ref={sidenavRef} style={{ backgroundColor: 'rgba(0, 0, 0, 0.8)'}}>
        <NavbarTabs onSelect={handleClick}/>
      </ul>
    </>
  )
}

export default Navbar;